import adminSlice from '@/lib/store/features/admin/adminSlice'
import formSlice from '@/lib/store/features/form/formSlice'
import {configureStore} from '@reduxjs/toolkit'
import upgradFormSlice from "@/lib/store/features/upgrad-form/upgradFormSlice";
import upgradCoSignerFormSlice from "@/lib/store/features/upgrad-cosigner-form/upgradFormSlice";
import shinhanFormSlice from "@/lib/store/features/shinhan-form/formSlice";
import userSlice from "@/lib/store/features/user/userSlice";
import reapplyFormSlice from "@/lib/store/features/reapply-form/formSlice";

export const makeStore = () => {
    return configureStore({
        reducer: {
            form: formSlice.reducer,
            reappplyForm: reapplyFormSlice.reducer,
            admin: adminSlice.reducer,
            upgradFrom: upgradFormSlice.reducer,
            upgradCoSignerForm: upgradCoSignerFormSlice.reducer,
            shinhanForm: shinhanFormSlice.reducer,
            user: userSlice.reducer,
        },
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false})
    })
}

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']